import { FC } from 'react';
import { Card } from "@/components/ui/card";
import { ProfileForm } from '@/components/settings/ProfileForm';
import { NotificationsForm } from '@/components/settings/NotificationsForm';
import { SubscriptionInfo } from '@/components/settings/SubscriptionInfo';
import { useProfile } from '@/hooks/useProfile';

export const SettingsTab: FC = () => {
  const { userProfile, loadProfile } = useProfile();

  return (
    <Card className="p-6 bg-white shadow-sm border-[#E6EDF9]">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Columna izquierda - Formulario de Perfil */}
        <div className="space-y-8">
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-2 text-[#2B3674]">Perfil</h3>
            <p className="text-[#707EAE]">Actualiza tu información personal y preferencias.</p>
          </div>
          <ProfileForm userProfile={userProfile} onProfileUpdate={loadProfile} />
        </div>

        {/* Columna derecha - Notificaciones y Suscripción */}
        <div className="space-y-8">
          <div>
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2 text-[#2B3674]">Notificaciones</h3>
              <p className="text-[#707EAE]">Configura tus preferencias de notificación.</p>
            </div>
            <NotificationsForm />
          </div>
          
          <div>
            <SubscriptionInfo />
          </div>
        </div>
      </div>
    </Card>
  );
};
